export default '1.10.0';



// WEBPACK FOOTER //
// ./src/version.js